import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as GC from "../../../../common/common";

class CreateBudget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: "",
      naamRequiredAlert: false,
      nummer: "",
      nummerRequiredAlert: false,

      active: true,
      requiredList: [
        { name: "naam", alertState: "naamRequiredAlert" },
        { name: "nummer", alertState: "nummerRequiredAlert" },
      ],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    this.state.requiredList.forEach((item) => {
      if (value != "" && name == item.name) {
        this.setState({ [item.alertState]: false });
      }
    });
  }

  async handleSubmit() {
    $("#cover-spin").show(0);

    var model = {
      relationships: { definition: { code: "GROOTBOEKNUMMER" } },
      content: {
        algemeen: {
          actief: this.state.active,
          nummer: this.state.nummer,
          naam: this.state.naam,
        },
      },
    };

    this.state.naam == ""
      ? await this.setState({ naamRequiredAlert: true })
      : await this.setState({ naamRequiredAlert: false });
    this.state.nummer == ""
      ? await this.setState({ nummerRequiredAlert: true })
      : await this.setState({ nummerRequiredAlert: false });

    let isUnique = true;
    let uniqueModel = {
      content: [
        {
          and_or: "AND",
          datatype: "STRING",
          key: "algemeen-code",
          values: [this.state.code],
        },
      ],
      definitions: [process.env.REACT_APP_GROOTBOEK],
      sorting: [],
    };

    //** code isunique control.
    await omnimap
      .FillTableAction(uniqueModel, 1, window.$catalog_management_units_token)
      .then((result) => {
        if (result.data && result.data.length > 0) {
          isUnique = false;
          this.setState({
            codeRequiredAlert: true,
            codeAlertText: "is not unique",
          });
        }
      });

    if (
      this.state.naamRequiredAlert !== true &&
      this.state.nummerRequiredAlert !== true &&
      isUnique === true
    ) {
      omnimap
        .SaveOrEditAction(
          model,
          "POST",
          "",
          window.$catalog_management_units_token
        )
        .then((data) => {
          CallBackFunctions.grootboeknummerSavedCallBack(
            window.$catalog_management_units_token
          );
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      $("#cover-spin").hide(0);
    }
  }

  async componentDidMount() {
    const _this = this;
    $(document).on("click", "#create_grootboeknummer", function () {
      $("#create_grootboeknummer_modal").modal("show");
      _this.setState({
        nummer: GC.epoch()
      })
    });
  }

  render() {
    return (
      <div
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        id="create_grootboeknummer_modal"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Nieuwe Grootboekrekening</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <br/>
            <div className="modal-body">
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Naam Grootboekrekening*
              </label>{" "}
              <br/>
              <label
                className={
                  this.state.naamRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} required
              </label>
              <input
                type="input"
                className="form-control"
                placeholder="Naam"
                name="naam"
                value={this.state.naam}
                autoComplete="off"
                onChange={this.handleInputChange}
              />
              <br/>
              <label
                className={
                  this.state.nummerRequiredAlert
                    ? "modale-submit-alert-block"
                    : ""
                }
              >
                Nummer *
              </label>{" "}
              <label
                className={
                  this.state.nummerRequiredAlert
                    ? "modale-submit-alert-block"
                    : "modale-submit-alert-none"
                }
              >
                {"\u00A0"} required
              </label>
              <input
                type="number"
                className="form-control"
                name="nummer"
                autoComplete="off"
                value={this.state.nummer}
                onChange={this.handleInputChange}
              />
              <br/>
              <label>Actief</label>
              <label className="switch">
                <input
                  type="checkbox"
                  defaultChecked
                  name="active"
                  value={this.state.active}
                  onChange={this.handleInputChange}
                />
                <span className="slider-checkbox round" />
              </label>
              <br />
              <br />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn-modal"
                onClick={this.handleSubmit.bind(this)}
              >
                Verwerken
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateBudget;
